module.exports = __webpack_public_path__ + "img/roach-motel.a37db2ec.png";